import { useMutation } from "@tanstack/vue-query";
import ActivityLog from "@/services/activity-log";
import type { RegisterActivityLog } from "@/dtos/ActivityLog.dto";

export function useRegisterActivityLog() {
  return useMutation({
    mutationFn: async (payload: RegisterActivityLog) => {
      const result = await ActivityLog.registerActivityLog(payload);
      if (result.data.status) return result.data.data;
      throw new Error(result.data.msg || "Failed to register activity log");
    },
    // No cache invalidation — write-only log
  });
}
